import type { ReactElement } from 'react';

import { PersonPicker } from '@/features/people/components/PersonPicker';
import type { PersonSelection } from '@/features/people/types';
import { usePermission } from '@/hooks/usePermission';

// Dueño de proceso (G3-3, 04-GC-P08 §5): una persona de la organización (sin invitaciones
// ni proveedores). Ofrece solo lo que el API permite a quien elige: buscar personas exige
// gestionar usuarios o roles; agregar al QMS a alguien del LMS exige gestionar roles.

export type OwnerSelection = Extract<PersonSelection, { kind: 'qms' | 'lms' }>;

const LABEL = 'Dueño de proceso (opcional)';

export function OwnerField({
  value,
  onChange,
}: {
  value: OwnerSelection | null;
  onChange: (next: OwnerSelection | null) => void;
}): ReactElement {
  const canManageRoles = usePermission('system:roles:manage');
  const canManageUsers = usePermission('system:users:manage');
  const canSearch = canManageRoles || canManageUsers;

  if (value !== null) {
    return (
      <div className="fld">
        <span className="fld-lab">{LABEL}</span>
        <div className="person-chosen">
          <strong>{value.name}</strong>
          <span className="soft">
            {value.kind === 'qms' ? 'En el QMS' : 'Del LMS: se agregará al QMS al guardar'}
          </span>
          <button type="button" className="btn mut sm" onClick={() => onChange(null)}>
            {canSearch ? 'Cambiar' : 'Quitar'}
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="fld">
      <span className="fld-lab">{LABEL}</span>
      {canSearch ? (
        <PersonPicker
          allowInvite={false}
          allowExternal={false}
          allowLms={canManageRoles}
          onSelect={(s) => s.kind !== 'invite' && onChange(s)}
        />
      ) : (
        <p className="fld-note">
          Tu rol no puede buscar personas: pide a un administrador del QMS que asigne el dueño.
        </p>
      )}
    </div>
  );
}
